/*******************************************************************************
CANCEL COMMENT REPLY
Closes the reply form and add it back to its normal spot.
*******************************************************************************/

export default async function triggerCommentReply(e) {

    // Prevents the form from submitting
    e.preventDefault();

    const $cancelButton = $(e.currentTarget);

    // Get the parent comment and our target form
    const $comments = $cancelButton.parents('.article-comments');
    const $form = $('#articleComments');

    // Setup the form
    $form.find('textarea').val('');
    $form.find('input[name="parentComment"]').val('');

    // Grab the original button html from the data attribute
    const $submitButton = $form.find('.submit-reply-form');
    const origButtonHTML = $submitButton.data('origbuttonhtml');

    // Reset the button text
    $submitButton.safehtml(origButtonHTML);

    // Hide the cancel button
    $cancelButton.hide();

    // Move the form
    $form.detach().appendTo($comments);

}
